import { AxiosError, AxiosResponse } from 'axios';
import { buildWorkoutUpdateFromRetrieve } from 'pages/private/owner/Workouts/Programming/components/AssignWorkoutModal/utils/templateToWorkoutWrite';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import type { ErrorMessage, Workout, WorkoutRetrieve } from 'types';
import { client } from 'utils/api-client';

interface ToggleVisibilityInput {
  workoutId: string;
  isVisibleToAthletes: boolean;
}

export default function useToggleWorkoutVisibility(): UseMutationResult<
  AxiosResponse<Workout>,
  AxiosError<ErrorMessage>,
  ToggleVisibilityInput
> {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ workoutId, isVisibleToAthletes }: ToggleVisibilityInput) => {
      const { data } = await queryClient.fetchQuery(
        ['workouts', workoutId],
        () => client.get<WorkoutRetrieve>(`workouts/${workoutId}/`),
        { staleTime: 0 },
      );

      return client.put<Workout>(
        `workouts/${workoutId}/`,
        buildWorkoutUpdateFromRetrieve(data, { isVisibleToAthletes }),
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('workouts');
      },
    },
  );
}
